module.exports = __webpack_public_path__ + "img/seguimiento.ca77d358.png";